import { render, staticRenderFns } from "./SizesAmount.vue?vue&type=template&id=7303d1ed&"
import script from "./SizesAmount.vue?vue&type=script&lang=js&"
export * from "./SizesAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports